import useRestApi from "helpers/useRestApi";

interface ConnectionCodeResponseType {
  data: {
    code: string;
    expired: boolean;
    schoolName: string;
  };
}

export default function useVerifyConnectCode() {
  const [{ loading }, verifyCode] = useRestApi<ConnectionCodeResponseType>(
    {
      url: "/connect",
      method: "POST",
    },
    {
      manual: true,
    },
  );

  async function verifyConnectCode(connectCode: string) {
    try {
      const { data } = await verifyCode({ data: { code: connectCode } });
      return data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }

  return { loading, verifyConnectCode };
}
